<template>
    <div class="filter-box">
      <type  v-on:changeCashFilter="changeCashValue"/>
      <search class="search" v-on:changeCashFilter="changeCashValue"/>
    </div>
</template>

<script>
import type from '../common/filters/cashbox/type'
import search from '../common/filters/cashbox/search'
export default {
  name: 'CashFilter',
  components: {search, type},
  methods: {
    changeCashValue () {
      this.$emit('changeCashFilter')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cashbox/CashFilter.vue